<template>
  <Layout title="About">
    <div class="page">
      <div class="hero">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12">
              <h1 class="text-center">We're Clausify</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <p>
              Maecenas faucibus mollis interdum. Curabitur blandit tempus
              porttitor. Maecenas sed diam eget risus varius blandit sit amet
              non magna. Maecenas faucibus mollis interdum. Donec ullamcorper
              nulla non metus auctor fringilla.
            </p>
            <p>
              Donec sed odio dui. Aenean lacinia bibendum nulla sed consectetur.
              Curabitur blandit tempus porttitor. Fusce dapibus, tellus ac
              cursus commodo, tortor mauris condimentum nibh, ut fermentum massa
              justo sit amet risus. Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Curabitur blandit tempus porttitor. Cras justo
              odio, dapibus ac facilisis in, egestas eget quam.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <TutorialVideo />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import TutorialVideo from '@/Shared/TutorialVideo';

export default {
  components: {
    Layout,
    TutorialVideo,
  },
};
</script>
